// extracted by mini-css-extract-plugin
export default {"container":"CardView_container__7g5DF"};